import qs from 'query-string';

const AllowedParamList = {
  minAnnualSalary: {
    type: 'number',
    unique: true,
  },
  providers: {
    type: 'string',
    unique: false,
  },
  needs: {
    type: 'string',
    unique: false,
  },
  grossArea: {
    type: 'number',
    unique: true,
  },
  loanAmount: {
    type: 'number',
    unique: true,
  },
  repaymentPeriodM: {
    type: 'number',
    unique: true,
  },
  repaymentPeriodY: {
    type: 'number',
    unique: true,
  },
  minMonthlySalary: {
    type: 'number',
    unique: true,
  },
  investmentTypes: {
    type: 'string',
    unique: false,
  },
  platformFeatures: {
    type: 'string',
    unique: false,
  },
  promotions: {
    type: 'string',
    unique: false,
  },
  privileges: {
    type: 'string',
    unique: false,
  },
};

export function getFunnelQueryFromSearchParams(search) {
  const queryObject = qs.parse(search);
  if (queryObject && queryObject.funnelQuery) {
    try {
      return JSON.parse(queryObject.funnelQuery);
    } catch (error) {
      console.log(error);
      return null;
    }
  }
  return null;
}

export function getIsEditingFunnelFromSearchParams(search) {
  const queryObject = qs.parse(search);
  return queryObject && (queryObject.isEditingFunnel === 'true'
    || queryObject.isEditingFunnel === true);
}

export const parseSearchParamsFilterValues = (search, setError) => {
  const parsed = qs.parse(search);
  let isParamsValuesError = false;
  const returnObject = Object.entries(parsed)
    .filter(([key]) => AllowedParamList?.[key])
    .reduce((a, [key, value]) => {
      const paramType = AllowedParamList[key].type;
      const isParamUnique = AllowedParamList[key].unique;
      if (Array.isArray(value)) {
        if (isParamUnique) {
          isParamsValuesError = true;
          return (a);
        }
        const validateParamType = value.reduce((validType, currentValue) => {
          if (paramType === 'number') return validType || Number.isNaN(Number(currentValue));
          return validType;
        }, false);
        isParamsValuesError = isParamsValuesError || validateParamType;
        return ({ ...a, [key]: value });
      }
      if (paramType === 'number') isParamsValuesError = isParamsValuesError || Number.isNaN(Number(value));
      return ({ ...a, [key]: value });
    }, {});

  if (setError) setError(isParamsValuesError);
  return { returnObject, isParamsValuesError };
};
